var map = {
	"./ADVANCED_LOGIC_PLUGIN.svg": "90ca",
	"./API_PLUGIN.svg": "4b90",
	"./APPROVAL_PLUGIN.svg": "695b",
	"./BLOCKCHAIN_EVENT_PLUGIN.svg": "b7f0",
	"./BLOCKCHAIN_PLUGIN.svg": "b8b5",
	"./DATA_EXPORT_PLUGIN.svg": "a912",
	"./EXCLUSIVE_GATEWAY_PLUGIN.svg": "cb8f",
	"./EXPOSE_API_PLUGIN.svg": "0d6b",
	"./EXTERNAL_PLUGIN.svg": "73b4",
	"./EXTERNAL_SOURCE_PLUGIN.svg": "c329",
	"./GENERAL_END_PLUGIN.svg": "e93e",
	"./GENERAL_START_PLUGIN.svg": "9f7f",
	"./GENERATE_DOCUMENT_PLUGIN.svg": "66ab",
	"./JOIN_GATEWAY_PLUGIN.svg": "6ad9",
	"./PARALLEL_GATEWAY_PLUGIN.svg": "f241",
	"./PROCESS_PLUGIN.svg": "02d5",
	"./START_BLOCKCHAIN_EVENT_PLUGIN.svg": "60da",
	"./TASK_PLUGIN.svg": "1ce9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ff32";